export const urls = {
    endpoint: process.env.REACT_APP_API_URL,

    logout: '/logout',
    login: '/auth/login',
    signup: '/auth/create-bor-user',
    profile_user_data: '/auth/access-token',

    searchDetails: '/bor-search/get_psc',
    PSCDetails: '/bor-search/get_psc_details',
    search_feedback: '/bor-search/post-feedback',

    dataDownload: '/bor-psc/date-range',
    recover_password: '/recover_password',
    userTypes: '/userTypes',
    getPortalUser: '/getPortalUser',
    update_portal_user: '/update_portal_user',
    contact_us: '/contact_us',

    total_visits: `/bor-psc/total-visits`,

    // headers
    headers: {
        "Accept": "application/json",
        "Access-Control-Allow-Headers": "*", // this will allow all CORS requests
        "Access-Control-Allow-Methods": 'OPTIONS,POST,GET,DELETE,PUT', // this states the allowed methods
        "Content-Type": "application/json" // this shows the expected content type
    }
}
